import request from '../utils/service';
const api = {
    getAppName:function(data){
        return request({
            url:'/basic/v2/api/applicationInfos',
            method: 'get',
            params: data
        });
    },
    registorSendCoupon: function(data) {
        return request({
            url:'/coupon/v2/api/registorSendCoupon',
            method: 'post',
            data: data
        });
    },
    sendVerifyCode:function(data){
        return request({
            url:'/driver/v2/api/sendVerifyCode',
            method: 'post',
            data: data
        });
    },
    login:function(data){
        return request({
            url:'/auth/v2/api/driver/login',
            method: 'post',
            data: data
        });
    },
    getUserInfo:function(data){
        return request({
            url:'/auth/v2/api/driver/loginInfo',
            method: 'get',
            params: data
        });
    },
    logOut:function(data){
        return request({
            url:'/auth/v2/api/driver/logout',
            method: 'get',
            params: data
        });
    },
    setPsd:function(data){
        return request({
            url:'/driver/v2/api/resetPassword',
            method: 'put',
            data: data
        });
    },
    updatePsd:function(data){
        return request({
            url:'/driver/v2/api/password',
            method: 'put',
            data: data
        });
    },
    registor:function(data){
        return request({
            url:'/driver/v2/api/register',
            method: 'post',
            data: data
        });
    },
    isPhoneRegistered:function(data){
        return request({
            url:'/driver/v2/api/isPhoneRegistered',
            method: 'post',
            data: data
        });
    },
    viewNotice:function(data){
        return request({
            url:'/basic/v2/api/viewNotice',
            method: 'get',
            params: data
        });
    },
    loginByVerifyCode:function(data){
        return request({
            url:'/auth/v2/api/driver/loginByVerifyCode',
            method: 'post',
            data: data
        });
    },
    getShotMsgCode:function(data){
        return request({
            url:'/driver/v2/api/sendVerifyCode',
            method: 'post',
            data: data
        });
    },
    getChallengeCode:function(data){
        return request({
            url:'/auth/v2/api/getChallengeCode',
            method: 'post',
            data: data
        });
    },
    checkAccount:function(data){
        return request({
            url: '/auth/v2/api/checkAccount',
            method: 'post',
            data: data
          });
    },
    // 微信一键登录获取跳转地址
    getWebGateWayUrl:function(data){
        return request({
            url:'/auth/v2/api/wechat/oAuthUrl',
            method: 'get',
            params: data
        });
    },
    // 微信一键登录状态 是否需要绑定
    getWxLoginStatus:function(data){
        return request({
            url: '/auth/v2/api/driver/oAuthLogin',
            method: 'post',
            data: data
          });
    }
};

export default api;